import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IMakePersonUserForm } from "./MakePersonUserSlider";
import { Input } from "@velocity-ehs/component-library";
import { emailRegExp } from "../../supportFunctions/ValidationHelpers";

interface MakePersonUserFormProps {
  formMethods: UseFormReturn<IMakePersonUserForm>;
  createUserFromPersonCallback: (formValues: IMakePersonUserForm) => void;
}

const MakePersonUserForm = ({
  formMethods,
  createUserFromPersonCallback,
}: MakePersonUserFormProps) => {
  const { t } = useTranslation();

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = formMethods;

  return (
    <form
      id="makePersonUserForm"
      onSubmit={handleSubmit(createUserFromPersonCallback)}
    >
      <Input
        control={control}
        name="username"
        label={t("universal_Username")}
        rules={{
          required: t("customer_Form_Admin_User_Username_Required"),
          pattern: {
            value: /^\s*[^+\\;,]+\s*$/i,
            message: t("message_invalid_username"),
          },
          maxLength: {
            value: 64,
            message: t(
              "customer_Form_Admin_User_Username_Max_Length_Validation"
            ),
          },
        }}
        errorMessage={errors ? errors.username?.message : undefined}
      />
      <Input
        control={control}
        name="email"
        label={t("universal_Email")}
        rules={{
          required: t("customer_Form_Admin_User_Email_Required"),
          maxLength: {
            value: 100,
            message: t("max_length_100_char_form_validation"),
          },
          pattern: {
            value: emailRegExp,
            message: t("message_invalid_email_address"),
          },
        }}
        errorMessage={errors && errors.email?.message}
      />
      <Input
        control={control}
        name="firstName"
        label={t("universal_First_Name")}
        rules={{
          required: t("customer_Form_Admin_User_First_Name_Required"),
          maxLength: {
            value: 100,
            message: t("max_length_100_char_form_validation"),
          },
        }}
        errorMessage={errors ? errors.firstName?.message : undefined}
      />
      <Input
        control={control}
        name="lastName"
        label={t("universal_Last_Name")}
        rules={{
          required: t("customer_Form_Admin_User_Last_Name_Required"),
          maxLength: {
            value: 100,
            message: t("max_length_100_char_form_validation"),
          },
        }}
        errorMessage={errors ? errors.lastName?.message : undefined}
      />
    </form>
  );
};

export { MakePersonUserForm };
